'use strict';

import { Entity } from '../Entity';
import { UserFlow } from '../User/UserFlow';
import { UserFlowStage } from '../User/UserFlowStage';
import { Ind } from './Ind';

export class IndFlowAssignment extends Entity {
  protected id;

  protected flow;

  protected stage;

  protected ind;

  protected startAt;

  protected endAt;

  protected movedBy;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    if (data.flow) {
      const flow = new UserFlow();

      flow.hydrate(data.flow);

      this.flow = flow;
    }

    if (data.stage) {
      const stage = new UserFlowStage();

      stage.hydrate(data.stage);

      this.flow = stage;
    }

    if (data.ind) {
      const ind = new Ind();

      ind.hydrate(data.ind);

      this.ind = ind;
    }

    if (data.startAt) {
      const iso = data.startAt.date.replace(' ', 'T') + (data.startAt.timezone ? '' : 'Z');
      const d = new Date(iso);
      this.startAt = isNaN(d.getTime()) ? null : d;
    }

    if (data.endAt) {
      const iso = data.endAt.date.replace(' ', 'T') + (data.endAt.timezone ? '' : 'Z');
      const d = new Date(iso);
      this.endAt = isNaN(d.getTime()) ? null : d;
    }
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getFlow() {
    return this.flow;
  }

  public setFlow(flow) {
    this.flow = flow;

    return this;
  }

  public getStage() {
    return this.stage;
  }

  public setStage(stage) {
    this.stage = stage;

    return this;
  }

  public getInd() {
    return this.ind;
  }

  public setInd(ind) {
    this.ind = ind;

    return this;
  }

  public getStartAt() {
    return this.startAt;
  }

  public setStartAt(startAt) {
    this.startAt = startAt;

    return this;
  }

  public getEndAt() {
    return this.endAt;
  }

  public setEndAt(endAt) {
    this.endAt = endAt;

    return this;
  }

  public getMovedBy() {
    return this.movedBy;
  }

  public setMovedBy(movedBy) {
    this.movedBy = movedBy;

    return this;
  }
}
